import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=c2f0ba42&lang=pug&"
import script from "./balance.vue?vue&type=script&lang=coffee&"
export * from "./balance.vue?vue&type=script&lang=coffee&"
import style0 from "./balance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports